let navDashboard = [
  {
    _name: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    fontIcon: 'fal fa-tachometer-alt',
    addLinkClasses: 'c-dashboard-link'
  },
];

let navNotifications = [
  {
    _name: 'CSidebarNavTitle',
    _children: ['']
  },
  // {
  //   _name: 'CSidebarNavItem',
  //   name: 'Dealer Agreement',
  //   to: '/dealer-agreement',
  //   fontIcon: 'fal fa-signature'
  // },
  {
    _name: 'CSidebarNavItem',
    name: 'SuperForm Updates',
    to: '/notifications',
    fontIcon: 'fal fa-bell'
  },
  {
    _name: 'CSidebarNavItem',
    name: 'My Account',
    to: '/account',
    fontIcon: 'fal fa-user'
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Product Catalog',
    to: '/product-catalog',
    fontIcon: 'fal fa-cubes'
  },
  {
    _name: 'CSidebarNavItem',
    name: 'My Price List',
    to: '/price-lists/current',
    fontIcon: 'fal fa-list-alt'
  },
];

let navOrders = [
  {
    _name: 'CSidebarNavTitle',
    _children: ['Orders']
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Current/Edit',
    to: '/orders/current',
    fontIcon: 'fal fa-list',
  },
  {
    _name: 'CSidebarNavItem',
    name: 'New',
    to: '/orders/add',
    fontIcon: 'fal fa-plus',
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Closed',
    to: '/orders/closed',
    fontIcon: 'fal fa-calendar-times',
  }
];

let navEstimates = [
  {
    _name: 'CSidebarNavTitle',
    _children: ['Estimates']
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Browse',
    to: '/estimates/list',
    fontIcon: 'fal fa-list'
  },
  {
    _name: 'CSidebarNavItem',
    name: 'Approve',
    to: '/estimates/approve',
    fontIcon: 'fal fa-check'
  },
  {
    _name: 'CSidebarNavItem',
    name: 'New',
    to: '/estimates/add',
    fontIcon: 'fal fa-plus'
  }
];

let navLibrary = [
  {
    _name: 'CSidebarNavTitle',
    _children: ['Library']
  },
];

let navTools = [
  {
    _name: 'CSidebarNavTitle',
    _children: ['Tools']
  },
  {
    _name: 'CSidebarNavItem',
    name: 'FAQ',
    to: '/tools/faq',
    fontIcon: 'fal fa-question'
  },
  {
    _name: 'CSidebarNavItem',
    name: 'How To\'s',
    to: '/tools/how-to',
    fontIcon: 'fal fa-video'
  },
];

let nav = [
  {
    _name: 'CSidebarNav',
    _children: []
  }
];

export {nav, navDashboard, navNotifications, navOrders, navEstimates, navLibrary, navTools};